<script>
export default {
  props: ['text'],
  render(createElement) {
    const text = this.text.split(/{.*}/i);
    let url = [];
    url = this.text.match(/{.*}/i);
    if (url === null) {
      url = [];
    }
    const rowlist = [];
    text.map((n, m) => {
      rowlist.push(n);
      if (url.length > m) {
        rowlist.push(url[m]);
      }
      return null;
    });
    const vnodes = rowlist.map((x, i) => {
      if (i % 2) {
        const n = x.replace(/[{}]/g, '').split(',');
        return createElement('a', { attrs: { href: n[1] } }, n[0]);
      }
      /* eslint-disable no-underscore-dangle */
      return this._v(x);
    }, this);
    return createElement(
      'p',
      vnodes,
    );
  },
};
</script>

<!-- Add 'scoped' attribute to limit CSS to this component only -->
<style scoped lang="scss">

a {
  text-decoration: underline !important;
}

.c-insertText--top3__text a {
  font-size:12px;
}
</style>
